import { Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class LoadingService {
  private activeRequests = 0;
  private readonly _isLoading = signal(false);

  public readonly isLoading = this._isLoading.asReadonly();

  show(): void {
    this.activeRequests++;
    this._isLoading.set(true);
  }

  hide(): void {
    if (this.activeRequests > 0) {
      this.activeRequests--;
    }

    if (this.activeRequests === 0) {
      this._isLoading.set(false);
    }
  }

  forceHide(): void {
    this.activeRequests = 0;
    this._isLoading.set(false);
  }
}
